import { DEFAULT_ANNUAL_DISCOUNT_PERCENTAGE } from "@/constants";
import { BillingInterval } from "@/graphql-types";
import { PlanStack, PlanType, PlanTypeEnum } from "@/types";
import { isEqual, pick } from "lodash";

// Gets a planStacks and extract a sample by planType, compares the same plan from both intervals, and returns the diffence in percentage number
// Defaults to DEFAULT_ANNUAL_DISCOUNT_PERCENTAGE if the input data doesn't suffice the logic
export const getAnnualDiscountPercentage = (
  planStacks: PlanStack[],
  planTypeSample: PlanType = PlanTypeEnum.Professional
): number => {
  const sampleStack = planStacks.find(
    (planStack) => planStack.planType === planTypeSample
  );

  if (!sampleStack) {
    return DEFAULT_ANNUAL_DISCOUNT_PERCENTAGE;
  }

  const yearlyPlan = sampleStack.plans.filter(
    (p) => p.interval === BillingInterval.year
  )[0];

  if (!yearlyPlan) {
    return DEFAULT_ANNUAL_DISCOUNT_PERCENTAGE;
  }

  const compareFields = ["tasks", "name", "zaps", "description"];

  // The yearly and monthly variants of the same plan.
  const monthlyPlan = sampleStack.plans.filter(
    (p) =>
      isEqual(pick(p, compareFields), pick(yearlyPlan, compareFields)) &&
      p.interval === BillingInterval.month
  )[0];

  const annualPrice = yearlyPlan.amount / 12; // per month
  const monthlyPrice = monthlyPlan?.amount;

  if (!annualPrice || !monthlyPrice) {
    return DEFAULT_ANNUAL_DISCOUNT_PERCENTAGE;
  }

  // return the difference in percentage
  return 100 - Math.round((annualPrice / monthlyPrice) * 100);
};
